import React, { useEffect, useState } from 'react';
import {
    AdvancedMarker,
    InfoWindow,
    useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';

export const MarkerWithInfoWindow = (props) => {
    const { children, onMarkerClick, companyId, updateMarkers, ...advancedMarkerProps } = props;
    const [markerRef, marker] = useAdvancedMarkerRef();

    useEffect(() => {
        if (marker && companyId) {
            updateMarkers(companyId, marker);
        }
    }, [marker]);

    return (
        <AdvancedMarker
            onClick={() => {
                if (marker) {
                    onMarkerClick(marker);
                }
            }}
            ref={markerRef}
            {...advancedMarkerProps}>
            {children}
        </AdvancedMarker>
    );
};

export default MarkerWithInfoWindow;